import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const wahooIntegrationService = {
    connect: () => {
        const clientId = import.meta.env.VITE_WAHOO_CLIENT_ID;

        if (!clientId) {
            console.error("Wahoo Client ID is missing. Check your .env files.");
            alert("Wahoo integration is not configured for this environment.");
            return;
        }

        const rawRedirectUri = window.location.origin + '/wahoo-callback';
        console.log("Initiating Wahoo Auth. Ensure this Redirect URI is allowed in Wahoo Portal:", rawRedirectUri);

        const redirectUri = encodeURIComponent(rawRedirectUri);

        // Wahoo scopes are space-separated. 
        const scope = encodeURIComponent('email user_read workouts_read power_zones_read routes_read offline_data');

        // Redirect to Wahoo OAuth page
        window.location.href = `https://api.wahooligan.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`;
    },

    handleCallback: async (code: string): Promise<void> => {
        try {
            // Send 'code' to backend to exchange for access_token securely (Client Secret stays on server)
            const redirectUri = window.location.origin + '/wahoo-callback';
            const exchangeWahooToken = httpsCallable(functions, 'exchangeWahooToken');
            await exchangeWahooToken({ code, redirectUri });
        } catch (error: any) {
            console.error("Failed to exchange Wahoo token:", error);

            // The 'functions/internal' error can happen for ANY backend error
            if (error.code === 'functions/internal' || error.message === 'internal') {
                console.error("Backend Error: Check your Firebase Functions console logs. The Wahoo API likely rejected the token exchange (e.g., bad client secret, mismatched redirect URI, or expired code).");
            }
            throw error;
        }
    },

    disconnect: async (): Promise<void> => {
        const disconnectWahoo = httpsCallable(functions, 'disconnectWahoo');
        await disconnectWahoo();
    },

    /**
     * Verifies the Wahoo connection by calling a Cloud Function that hits the Wahoo API.
     * Returns the user's name if valid, or null if invalid/expired.
     */
    verifyConnection: async (): Promise<string | null> => {
        try {
            const verifyWahooToken = httpsCallable(functions, 'verifyWahooToken');
            const result = await verifyWahooToken();
            const data = result.data as any;
            if (!data) return null;
            // Assuming the cloud function returns the Wahoo user profile object
            return data.first && data.last ? `${data.first} ${data.last}` : "Active";
        } catch (error) {
            console.error("Wahoo verification failed:", error);
            return null;
        }
    }
};